import React from 'react'
import './SubStepper.component.css'
import { IonBadge, IonCol, IonLabel, IonRow } from '@ionic/react'

export interface ISubStep {
  id: number
  title: string
}

export interface ISubStepperProps {
  currentStep: number
  stepLabel: string
  steps: ISubStep[]
  className?: string
}

const SubStepper: React.FC<ISubStepperProps> = ({ currentStep, stepLabel, steps, className = '' }) => {
  const displayTitle = steps?.find((step) => step.id === currentStep)?.title || ''

  const stepsLength = steps?.length || 0

  if (stepsLength === 0) {
    return null
  }

  return (
    <IonRow className={`sub-stepper-container ion-padding-start ion-padding-end ${className}`}>
      <IonCol>
        <IonBadge>{currentStep}</IonBadge>
        <IonLabel>{` of ${stepsLength} ${stepLabel} | `}</IonLabel>
        <IonLabel className='sub-stepper-title'>{displayTitle}</IonLabel>
      </IonCol>
    </IonRow>
  )
}

export default SubStepper
